import babelpolyfill from 'babel-polyfill'
import Vue from 'vue'
import App from './App'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import router from './routes'
import store from '@/store'
import components from './components'
import { showLoading, hideLoading } from '@/utils/loading';
import register from '@/components/DynamicForm/register';
import './styles/element-variables.scss'
Object.assign(Vue.prototype, { showLoading }, { hideLoading });
//import NProgress from 'nprogress'
//import 'nprogress/nprogress.css'
import routes from './routes'
import './permission'
import Mock from './mock'
import VModal from 'vue-js-modal'
Mock.bootstrap();
import 'font-awesome/css/font-awesome.min.css'

Vue.use(ElementUI)
Vue.use(register)

VModal.rootInstance = App;
Vue.use(VModal, { dynamic: true, injectModalsContainer: true, dynamicDefaults: { clickToClose: false } })
// Vue.use(VueRouter)
// Vue.use(Vuex)
components.map(component => {
  Vue.component(component.name, component)
})
//NProgress.configure({ showSpinner: false });

// const router = new VueRouter({
//   routes
// })

// router.beforeEach((to, from, next) => {
//   // console.log(router.options.routes)
//   //NProgress.start();
//   if (to.path == '/login') {
//     sessionStorage.removeItem('user');
//   }
//   let user = JSON.parse(sessionStorage.getItem('user'));
//   if (!user && to.path != '/login') {
//     next({ path: '/login' })
//   } else {
//     next()
//   }
// })
new Vue({
  el: '#app',
  router,
  store,
  render: h => h(App)
})
// new Vue({
//   el: '#app',
//   //template: '<App/>',
//   router,
//   store,
//   //components: { App }
//   render: h => h(App)
// }).$mount('#app')




// WEBPACK FOOTER //
// ./src/main.js